import React from 'react';
import Section from '../Section/Section';
import { skills, experience, projects } from '../../data/portfolioData';
import './Stack.css';

// Every shipped piece of work and the stack it lists, newest first.
const WORKS = [
  ...experience.map((job) => ({ key: job.slug, name: job.company.split(' ')[0], stack: job.stack })),
  ...projects.map((p) => ({ key: p.slug, name: p.title, stack: p.technologies }))
];

// Each technology against the work that used it, most used first.
const MATRIX = (() => {
  const rows = new Map();
  WORKS.forEach((work, col) => {
    work.stack.forEach((tech) => {
      if (!rows.has(tech)) rows.set(tech, new Set());
      rows.get(tech).add(col);
    });
  });
  return [...rows.entries()]
    .map(([tech, cols], order) => ({ tech, cols, order }))
    .sort((a, b) => b.cols.size - a.cols.size || a.order - b.order);
})();

export const Stack = () => (
  <Section id="stack" path="stack" title="Stack">
    <dl className="stack-groups">
      {skills.map((group) => (
        <div className="stack-row" key={group.id}>
          <dt>{group.label}</dt>
          <dd>
            <ul className="tags">
              {group.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </dd>
        </div>
      ))}
    </dl>

    <details className="matrix-box">
      <summary>Where each technology shipped</summary>
      <p className="matrix-note">
        Built from the same data as the rest of this page: every role and
        project, and the stack each one lists.
      </p>
      <div className="matrix-scroll">
        <table className="matrix">
          <thead>
            <tr>
              <th scope="col">Technology</th>
              {WORKS.map((w) => (
                <th scope="col" key={w.key}>
                  {w.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {MATRIX.map((row) => (
              <tr key={row.tech}>
                <th scope="row">{row.tech}</th>
                {WORKS.map((w, col) => (
                  <td key={w.key}>
                    {row.cols.has(col) && (
                      <span className="matrix-on">
                        <span className="visually-hidden">used</span>
                      </span>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  </Section>
);

export default Stack;
